// extracted by mini-css-extract-plugin
export default {"cardRemoveButton":"cardRemoveButton___ndPBQ","cardRemoveButton--hasSticker":"cardRemoveButton--hasSticker___ZWVLn"};